// kfe-stat-row.js — text stat row: label left, value right, divider below
// (Brief 097).
//
// PORT TARGET: the word-count rows in the iOS KFELessonReportVC "Report on
// Activity" section.
//
// Props:
//   label: string
//   value: string|number
//
// Graceful degradation (Brief 097 success-criterion #13): when `value` is
// null / undefined / "" the row hides itself (`:host` collapses) so a parent
// can leave it mounted and let it self-hide.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFEStatRow extends KFEComponent {
  static props = ["label", "value"];
  static styles = `
    :host { display: block; }
    :host([hidden]) { display: none; }
    .row {
      display: flex; align-items: baseline; gap: 0.75rem;
      padding: 0.75rem 0;
      border-bottom: 1px solid var(--kfe-border);
    }
    .label { color: var(--kfe-fg); flex: 1; min-width: 0; font-size: 0.9rem; }
    .value {
      color: var(--kfe-accent);
      font-weight: 700; font-size: 1.1rem; white-space: nowrap;
    }
  `;

  render() {
    const label = /** @type {string} */ (/** @type {any} */ (this).label ?? "");
    const value = /** @type {any} */ (this).value;

    const missing = value === null || value === undefined || value === "";
    this.hidden = missing;
    if (missing) return html``;

    return html`
      <div class="row">
        <span class="label">${label}</span>
        <span class="value">${value}</span>
      </div>
    `;
  }
}
